import React from 'react';
import { Flex } from './base/layout-components';
import { TitleWithGraphIcon } from './TitleWithIcons';
import IconedValueLine from './IconedValueLine';

const ChartBox = ({ title, totalLine = {}, onIconClick, isOpen, children }) => {
  const { icon, sum, of, extraInfo } = totalLine;
  return (
    <Flex height='100%' width='100%' direction='column'>
      <TitleWithGraphIcon
        title={title}
        onClick={onIconClick}
        isOpen={isOpen}
        mb='medium'
      />
      <IconedValueLine
        icon={icon}
        value={sum}
        descriptor={of}
        extraInfo={extraInfo}
        mb='medium'
      />
      {children}
    </Flex>
  );
};

export default ChartBox;
